<script>
import StartRisk from "@/components/StartRisk.vue";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Home",
  components: {StartRisk}
}
</script>

<template>
  <div style="padding-top: 50px" align="middle">
    <!--    <h1>Upgrading...</h1>-->
    <h1>Turn Your Packaging into Your #1 Sales Driver.</h1>
    <b-card no-body class="overflow-hidden border-0 rounded-0 text-left align-middle" style="max-width: 75%;padding-bottom: 80px;padding-top: 80px">
      <b-row no-gutters align-v="center">

        <b-col md="9">
          <b-card-body style="margin-right: 20px">

            <b-card-sub-title class="h4" style="padding-top: 20px">Custom Packaging for Your Brand, A Reliable Partner
              for Your Growth.
            </b-card-sub-title>
            <b-card-text style="font-size: x-large">
              We are your end-to-end partner for custom boxes, bags, and branded packaging that captures attention and
              builds loyalty.
            </b-card-text>
          </b-card-body>
        </b-col>
        <b-col md="3">
          <b-card-img src="@/assets/1-1.jpg" alt="Image" class="rounded-0"></b-card-img>
        </b-col>
      </b-row>
    </b-card>
    <h1 style="padding-top: 80px;max-width: 75%">Custom Packaging Solution for Your Start-up and Growing Business</h1>
    <b-card no-body class="overflow-hidden border-0 rounded-0 text-left align-middle"
            style="max-width: 75%;padding-bottom: 80px;padding-top: 80px">
      <b-row no-gutters align-v="center">
        <b-col md="3">
          <b-card-img src="@/assets/1-2.jpg" alt="Image" class="rounded-0"></b-card-img>
        </b-col>
        <b-col md="9" class="align-middle">
          <b-card-body class="align-middle" style="margin-left: 40px">

            <b-card-text style="padding-top: 20px; font-size: large">
              <span class="font-weight-bold">Tailored & Brand-Centric Design:</span> Turn your ideals into reality,
              professional guidance to ensure that your packages are fully customized to align with your brand.
            </b-card-text>
            <b-card-text style="padding-top: 20px; font-size: large">
              <span class="font-weight-bold">Rapid Delivery:</span> Well-equipped facilities to provide you with
              comprehensive support and ensure that your delivery deadlines are met as quickly as possible.
            </b-card-text>
            <b-card-text style="padding-top: 20px; font-size: large">
              <span class="font-weight-bold">Seamless Full-Process Service:</span> You have a single point of contact
              and responsibility, simplifying the entire supply chain from initial design and material sourcing to
              production, finishing, and logistics.
            </b-card-text>
          </b-card-body>
        </b-col>

      </b-row>
    </b-card>
    <div style="padding-bottom: 80px;padding-top: 80px">
      <h1 style="max-width: 80%">Simple Process. Worry-Free Delivery.Your custom packaging, streamlined.</h1>
      <b-card-sub-title style="font-size: x-large">Your 4-Step Custom Packaging Journey</b-card-sub-title>
    </div>
    <b-card-group style="padding-top: 80px; max-width: 75%">
      <b-card class="overflow-hidden border-0 rounded-0">
        <b-img-lazy src="@/assets/2-1.png" top width="50%" height="50%"></b-img-lazy>
        <b-card-body>
          <b-card-title>Get a quote instantly</b-card-title>
          <b-card-text>
            Submit your request online for a prompt, clear quote.
          </b-card-text>
        </b-card-body>
      </b-card>
      <b-card class="overflow-hidden border-0 rounded-0">
        <b-img-lazy src="@/assets/2-2.png" top width="50%" height="50%"></b-img-lazy>
        <b-card-body>
          <b-card-title>Design & Approve</b-card-title>
          <b-card-text>
            Co-create the perfect design until your final approval.
          </b-card-text>
        </b-card-body>
      </b-card>
      <b-card class="overflow-hidden border-0 rounded-0">
        <b-img-lazy src="@/assets/2-3.png" top width="50%" height="50%"></b-img-lazy>
        <b-card-body>
          <b-card-title>Produce & Inspect</b-card-title>
          <b-card-text>
            Precision manufacturing followed by rigorous quality checks.
          </b-card-text>
        </b-card-body>
      </b-card>
      <b-card class="overflow-hidden border-0 rounded-0">
        <b-img-lazy src="@/assets/2-4.png" top width="50%" height="50%"></b-img-lazy>
        <b-card-body>
          <b-card-title>Deliver & Track</b-card-title>
          <b-card-text>
            Secure, on-time delivery with full visibility.
          </b-card-text>
        </b-card-body>
      </b-card>
    </b-card-group>
    <div style="padding-top: 120px">
      <h1 style="max-width: 80%">XIYUE Eco Package is your certified one-stop solution for all packaging and print
        needs.</h1>
      <b-card-sub-title style="font-size: x-large">Styles of Packaging & Printing solutions for your choose
      </b-card-sub-title>
      <b-card class="overflow-hidden border-0 rounded-0" style="padding-top: 80px;max-width: 75%;padding-bottom: 80px">
        <b-row no-gutters align-v="center">

          <b-col md="9">
            <b-card-body style="margin-right: 20px">
              <h2>Custom Boxes</h2>
              <b-card-text class="text-left" style="font-size: x-large;padding-top: 30px">
                <ul>
                  <li>Gift & Luxury Boxes – For an unforgettable unboxing experience.</li>
                  <li>Shipping & Mailing Boxes – For secure, cost-effective delivery.</li>
                  <li>Retail & Display Boxes – For food, cosmetics, electronics, standout shelf presence, etc.</li>
                </ul>
              </b-card-text>
            </b-card-body>
          </b-col>
          <b-col md="3">
            <b-card-img-lazy src="@/assets/3-1.jpg"></b-card-img-lazy>
          </b-col>
        </b-row>
      </b-card>
      <b-card class="overflow-hidden border-0 rounded-0" style="padding-top: 80px;max-width: 75%;padding-bottom: 80px">
        <b-row no-gutters align-v="center">
          <b-col md="3">
            <b-card-img-lazy src="@/assets/3-2.jpg"></b-card-img-lazy>
          </b-col>
          <b-col md="9">
            <b-card-body style="margin-left: 20px">
              <h2>Custom Bags</h2>
              <b-card-text class="text-left" style="font-size: x-large;padding-top: 30px">
                <ul>
                  <li>Gift & Premium Paper Bags – Elegant handles and finishes for a polished gift presentation.</li>
                  <li>Reusable & Eco Bags – Sustainable options for conscious brands and customers.</li>
                  <li>Pouch & Zipper Bags – Secure, resealable packaging for freshness and food protection.</li>
                </ul>
              </b-card-text>
            </b-card-body>
          </b-col>

        </b-row>
      </b-card>
      <b-card class="overflow-hidden border-0 rounded-0" style="padding-top: 80px;max-width: 75%;padding-bottom: 80px">
        <b-row no-gutters align-v="center">
          <b-col md="9">
            <b-card-body style="margin-right: 20px">
              <h2>Labels & wrapping paper & cards</h2>
              <b-card-text class="text-left" style="font-size: x-large;padding-top: 30px">
                <ul>
                  <li>Decorative Stickers & Packaging Labels – For essential information and premium branding.</li>
                  <li>Custom Gift Wrapping Paper – For a cohesive and memorable unboxing presentation.</li>
                  <li>Thank You Cards, Hang Tags & Inserts – To add a personal touch and key messages.</li>
                </ul>
              </b-card-text>
            </b-card-body>
          </b-col>
          <b-col md="3">
            <b-card-img-lazy src="@/assets/3-3.jpg"></b-card-img-lazy>
          </b-col>
        </b-row>
      </b-card>
      <b-card class="overflow-hidden border-0 rounded-0" style="padding-top: 80px;max-width: 75%;padding-bottom: 80px">
        <b-row no-gutters align-v="center">
          <b-col md="3">
            <b-card-img-lazy src="@/assets/3-4.jpg"></b-card-img-lazy>
          </b-col>
          <b-col md="9">
            <b-card-body style="margin-left: 20px">
              <h2>Custom Printing service</h2>
              <b-card-text class="text-left" style="font-size: x-large;padding-top: 30px">
                <ul>
                  <li>Books & Brochures – To tell your complete brand story with authority.</li>
                  <li>Product Catalogs – To showcase your full range in a compelling format.</li>
                  <li>Folding Leaflets & Flyers – For concise, impactful information distribution.</li>
                </ul>
              </b-card-text>
            </b-card-body>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <div style="padding-top: 120px">
      <div style="max-width: 75%">
        <StartRisk></StartRisk>
      </div>
      <div style="padding-top: 120px;max-width: 75%;padding-bottom: 80px">
        <h1>Ready to stand out your package</h1>
        <b-card-sub-title style="font-size: x-large">Elevate Your Brand, From the Shelf to the Unboxing.
        </b-card-sub-title>
        <b-card class="overflow-hidden border-0 rounded-0" style="padding-top: 80px">
          <b-row no-gutters align-v="center">
            <b-col md="4">
              <b-card-img-lazy src="@/assets/5-1.jpg"></b-card-img-lazy>
            </b-col>
            <b-col md="8">
              <b-card-body style="margin-left: 20px">

                <b-card-text class="text-left" style="font-size: larger">
                  In a world of noise, true luxury communicates in a whisper.
                  While others shout, we believe in the eloquence of intention—the three-second dialogue between your
                  product and the discerning eye. It begins with a gaze held, a story felt before it’s read, an
                  invitation
                  extended not by words, but by presence.
                  At XIYUE, we compose packaging as signature art. Each fold, finish, and texture is a deliberate
                  stroke—crafted not to contain, but to reveal. We turn the silent moment of encounter into a lasting
                  memory, where quality is understood before it is explained. Here, packaging is never a mere vessel. It
                  is
                  the quiet ambassador of your legacy.
                  Because true distinction isn’t seen from across the room—it is felt in the hand, remembered in the
                  mind,
                  and kept in the heart.
                  Let us craft the quiet that speaks louder.
                </b-card-text>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>